"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneContextMenuItem = exports.ContextMenuItem = void 0;
var localization_1 = require("devextreme/localization");
var ContextMenuItem = (function () {
    function ContextMenuItem(id, options) {
        var _a, _b, _c;
        this.id = id;
        this.localizationId = options.localizationId;
        this.text = options.text ? options.text : (this.localizationId ? localization_1.formatMessage(this.localizationId) : '');
        this.icon = options.icon;
        this.items = options.items;
        this.beginGroup = (_a = options.beginGroup) !== null && _a !== void 0 ? _a : false;
        this.disabled = (_b = options.disabled) !== null && _b !== void 0 ? _b : false;
        this.visible = (_c = options.visible) !== null && _c !== void 0 ? _c : true;
    }
    return ContextMenuItem;
}());
exports.ContextMenuItem = ContextMenuItem;
function cloneContextMenuItem(item) {
    return new ContextMenuItem(item.id, {
        text: item.text,
        localizationId: item.localizationId,
        beginGroup: item.beginGroup,
        icon: item.icon,
        items: item.items,
        disabled: item.disabled,
        visible: item.visible,
    });
}
exports.cloneContextMenuItem = cloneContextMenuItem;
